import { render } from "./BtnStartAttendanceSchedule.vue?vue&type=template&id=06bf2b6f"
import script from "./BtnStartAttendanceSchedule.vue?vue&type=script&lang=js"
export * from "./BtnStartAttendanceSchedule.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__